import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import BooksLabeledContainer from '../../../../components/books/model1/BooksLabeledContainer';
import BooksTextInput, {
  TextInputType,
} from '../../../../components/books/model1/forms/BooksTextInput';
import * as IBooks from '../../../../interfaces/merchants/resources/books';
import ErrorMessage from './InputUserInfoErrorMessage';

interface Props extends InjectedIntlProps {
  survey: IBooks.Survey;
  onChange: (name: string, value: string) => void;
  name: string;
  value: string;
}

const sanitize = (s: string): string => s.replace(/\r\n?/g, '\n');

export const submittable = (
  survey?: IBooks.Survey,
  value?: string,
): boolean => {
  if (!survey) {
    return true;
  }
  if (!survey.required) {
    return true;
  }
  if (!!survey.question) {
    if (!!value) {
      return !!value && sanitize(survey.question) !== sanitize(value);
    }
  }
  return !!value;
};

class InputUserInfoSurvey extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    const {
      currentTarget: { name, value },
    } = e;
    this.props.onChange(name, value);
  }

  public render() {
    const { survey, name, value, intl } = this.props;
    return (
      <div>
        <BooksLabeledContainer
          label={intl.formatMessage({ id: `books.formsLabel.survey` })}
          paddingTop={true}
          requiredLabel={survey.required}
          errorStyle={survey.errors && survey.errors.length !== 0}
        >
          <BooksTextInput
            type={TextInputType.TextArea}
            name={name}
            value={value || survey.question || ''}
            onChange={this.handleChange}
          />
        </BooksLabeledContainer>
        <ErrorMessage fieldSource={survey} />
      </div>
    );
  }
}

export default injectIntl(InputUserInfoSurvey);
